import { useState } from 'react'
import { IconSectionHeader, ChartLogList } from '..'
import SignatureModal from './SignatureModal'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { Resident } from '@lmc/ts-common'

type SignatureSectionProps = {
  helpUrl?: string
  resident: Resident
  logs: Array<any>
  onSubmit: (result: object) => void
  buttonLabel: string
  footerLabel?: string
  confirmText: string
  title: string
  isSubmitting: boolean
  isModalOnly?: boolean
  isModalVisible?: boolean
  onClose?: () => void
  customSignButton?: boolean
  onSuccessClose?: () => void
  isGP?: boolean
  informedConsentEnabled?: boolean
}

const renderModal = (
  props: SignatureSectionProps,
  isShowing: boolean | undefined | null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose: (() => void) | undefined = () => {}
) => (
  <SignatureModal
    onSuccessClose={props.onSuccessClose}
    resident={props.resident}
    footerLabel={props.footerLabel}
    confirmText={props.confirmText}
    isShowing={isShowing || false}
    isSubmitting={props.isSubmitting}
    onSubmit={props.onSubmit}
    onClose={onClose}
    isGP={props.isGP}
  />
)

const SignatureSection = (props: SignatureSectionProps) => {
  const {
    resident,
    logs,
    buttonLabel,
    title,
    helpUrl,
    customSignButton,
    // Modal Only Props - used in the big guy (Consent modal)
    isModalOnly,
    isModalVisible,
    onClose,
    informedConsentEnabled,
  } = props

  if (!resident) return null
  if (isModalOnly) return renderModal(props, isModalVisible, onClose)

  // create a state that will contain our image url
  const [showingSignatureModal, setShowingSignatureModal] =
    useState<boolean | null>(null)

  return (
    <div style={styles.container}>
      <IconSectionHeader
        title={title}
        buttonLabel={buttonLabel}
        buttonType="success"
        onClickButton={() => setShowingSignatureModal(true)}
        buttonGlyph="pencil"
        customSignButton={customSignButton}
        noWrapContainer
        buttonDisabled={informedConsentEnabled}
        buttonTooltip={informedConsentEnabled ? 'Consent to Care Plans by linking Consent Forms' : undefined}
      />
      <div style={styles.body}>
        {logs && logs.length ? (
          <ChartLogList
            fixedPictures
            alignLeft
            logs={logs}
            style={styles.logList}
          />
        ) : (
          // @ts-ignore
          <EmptyState
            title="Shoot... No data to show you"
            description="You haven't added any signatures yet."
            icon={<NoDataIcon />}
          >
            {helpUrl && (
              <a href={helpUrl} target="_blank" rel="noreferrer">
                Find out more
              </a>
            )}
          </EmptyState>
        )}
      </div>
      {renderModal(props, showingSignatureModal, () =>
        setShowingSignatureModal(false)
      )}
    </div>
  )
}

const styles = {
  container: { paddingTop: 24 },
  logList: {
    marginBottom: 24,
    maxWidth: 640,
  },
  body: {
    paddingTop: 12,
  },
}

export default SignatureSection
